// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3mlIn","tab":"Tabs_tab__1epEl","tabActive":"Tabs_tabActive__HJyr9"};